import type { JobOpeningStatus, StageBar, StageBarKey } from '@nest-recruit/shared';

// Where a job list row opens (Redesign Group 2, Jobs.dc.html): a draft opens its setup, any other
// job the stage where people are now — the leftmost stage with people, the one the mini bar marks
// current (§L33). A job with nobody in it yet opens the job's own address, as before.

/** `/jobs/{id}/setup` is stage ① Job, the builder (`jobPageViewOf`). */
export const SETUP_SEGMENT = 'setup';

/**
 * The bar without the stages of switched-off modules (#13), as the job page draws it. A stage's
 * state is kept, so a hidden current stage leaves no other stage marked current.
 */
export function shownStageBar(bar: StageBar, hiddenStages: ReadonlySet<StageBarKey>): StageBar {
  return { ...bar, stages: bar.stages.filter((stage) => !hiddenStages.has(stage.key)) };
}

/** The `/jobs/{id}/{segment}` a row opens, or null for the job's own address. */
export function jobRowSegment(status: JobOpeningStatus, bar: StageBar | null): string | null {
  if (status === 'draft') return SETUP_SEGMENT;
  const current = bar?.stages.find((stage) => stage.state === 'current' && stage.key !== 'job');
  return current?.key ?? null;
}

export function jobRowHref(jobId: string, segment: string | null): string {
  return segment === null ? `/jobs/${jobId}` : `/jobs/${jobId}/${segment}`;
}
